import React from 'react';
import styles from './DescribeSection.module.css';
import image from './images/team.png';
import {
    OptimizedMotionH1,
    OptimizedMotionP,
} from '../../../shared/ui/optimized-motion/OptimizedMotion';

const DescribeSection: React.FC = () => {
    return (
        <div className={styles.container}>
            <img src={image} alt="describe" className={styles.image} />
            <div>
                <OptimizedMotionH1 className={styles.title} type="slide-down" delay={0.2}>
                    Real‑Time Collaboration
                </OptimizedMotionH1>
                <OptimizedMotionP className={styles.description} type="slide-down" delay={0.4}>
                    Google‑Docs‑style editing for copy; Figma‑like commenting for visuals. See
                    feedback as it happens, resolve threads instantly, and watch the approval meter
                    move toward "Ready" in real time.
                </OptimizedMotionP>
            </div>
            <div className={styles.blur}></div>
        </div>
    );
};

export default DescribeSection;
